import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Receipt, Loader2, CheckCircle2, XCircle } from "lucide-react";
import { api, formatApiErrorDetail } from "@/lib/api";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [state, setState] = useState("verifying"); // verifying | success | error
  const [message, setMessage] = useState("");

  useEffect(() => {
    if (!token) {
      setState("error");
      setMessage("Missing verification token.");
      return;
    }
    api.post("/auth/verify-email", { token })
      .then((r) => { setState("success"); setMessage(r.data?.message || "Email verified."); })
      .catch((e) => { setState("error"); setMessage(formatApiErrorDetail(e.response?.data?.detail) || "Verification failed."); });
  }, [token]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 p-6" data-testid="verify-email-page">
      <div className="w-full max-w-sm bg-white border border-slate-200 rounded-xl shadow-sm p-8 text-center">
        <div className="flex items-center justify-center gap-2.5 mb-8">
          <div className="h-10 w-10 rounded-lg bg-blue-600 flex items-center justify-center">
            <Receipt className="h-5 w-5 text-white" strokeWidth={2.2} />
          </div>
          <div className="font-heading font-semibold text-slate-900 text-lg">Tax Flow</div>
        </div>
        {state === "verifying" && (<><Loader2 className="h-10 w-10 text-blue-600 mx-auto mb-3 animate-spin" /><p className="text-slate-500 text-sm">Verifying your email…</p></>)}
        {state === "success" && (<><CheckCircle2 className="h-10 w-10 text-emerald-500 mx-auto mb-3" /><h1 className="font-heading text-xl font-semibold text-slate-900">Email verified</h1><p className="text-slate-500 text-sm mt-2">{message}</p></>)}
        {state === "error" && (<><XCircle className="h-10 w-10 text-red-500 mx-auto mb-3" /><h1 className="font-heading text-xl font-semibold text-slate-900">Verification failed</h1><p className="text-slate-500 text-sm mt-2">{message}</p></>)}
        <Link to="/login" className="inline-block text-blue-600 text-sm mt-6 hover:underline" data-testid="verify-back-login">Go to sign in</Link>
      </div>
    </div>
  );
}
